import {
  Card,
  CardBody,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
} from '@chakra-ui/react';
import type { StoreGroupReportSummary } from 'services/interfaces/storeGroupReport';
import { formatCurrency } from './reportFormat';

interface ReportKpiCardsProps {
  summary: StoreGroupReportSummary;
}

// Mesmo padrão de card do NfseReport.tsx (SimpleGrid de Card/Stat), sem gráfico — decisão
// do Eden pra não introduzir lib nova só pro relatório de grupo.
const ReportKpiCards: React.FC<ReportKpiCardsProps> = ({ summary }) => {
  const cardBg = useColorModeValue('gray.50', 'gray.700');
  const { totals } = summary;

  const cards = [
    { label: 'Gerado', value: formatCurrency(totals.generated) },
    { label: 'Resgatado', value: formatCurrency(totals.redeemed) },
    { label: 'Expirado', value: formatCurrency(totals.expired) },
    { label: 'Recompra', value: formatCurrency(totals.repurchase) },
    {
      label: 'Saldo pendente (hoje)',
      value: formatCurrency(summary.pending_balance),
    },
    { label: 'Pedidos', value: String(totals.orders) },
  ];

  return (
    <SimpleGrid columns={{ base: 2, md: 3, lg: 6 }} spacing={4}>
      {cards.map((card) => (
        <Card key={card.label} bg={cardBg}>
          <CardBody py={3} px={4}>
            <Stat size="sm">
              <StatLabel color="gray.600" fontWeight="bold">
                {card.label}
              </StatLabel>
              <StatNumber fontSize="lg">{card.value}</StatNumber>
            </Stat>
          </CardBody>
        </Card>
      ))}
    </SimpleGrid>
  );
};

export default ReportKpiCards;
